import { defineStyle, extendTheme } from '@chakra-ui/react';

import { colors } from '../colors';
import { Alert } from './components/Alert';
import { Button } from './components/Button';
import { ChakraReactDatePicker } from './components/ChakraReactDatePicker';
import { Drawer } from './components/Drawer';
import { Modal } from './components/Modal';
import { Progress } from './components/Progress';
import { Stepper } from './components/Stepper';
import { Table } from './components/Table';
import { Tabs } from './components/Tabs';
import { Tag } from './components/Tag';
import { Tooltip } from './components/Tooltip';
import { FONT_FAMILY, BACKGROUND_COLORS } from './tokens';
import { resolveColor } from './utils';

export const theme = extendTheme({
  colors,
  components: {
    Alert,
    Button,
    ChakraReactDatePicker,
    Drawer,
    Modal,
    Progress,
    Stepper,
    Table,
    Tabs,
    Tag,
    Tooltip,
  },
  fonts: {
    heading: FONT_FAMILY.base.join(','),
    body: FONT_FAMILY.base.join(','),
  },
  styles: {
    global: defineStyle((props) => ({
      'body, #root': {
        background: resolveColor(props, BACKGROUND_COLORS.white.base),

        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      },
      // See https://github.com/chakra-ui/chakra-ui/issues/7629
      '.chakra-input__group': {
        isolation: 'auto !important',
      },
    })),
  },
});
